import React, { FunctionComponent, memo } from "react";

import { Header } from "@/components/Header";
import { IJobApplication, TJobApplicationStatuses } from "@/data/job-applications";
import { Flex, IStyleSize } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { TColorVariant } from "@/style/colorVariants";

interface IJobApplicationStatusProps extends Partial<IStyleSize>, Pick<IJobApplication, "status"> {}

type TStatusBadgeColorMap = Record<TJobApplicationStatuses, TColorVariant>;

const statusBadgeColorMap: TStatusBadgeColorMap = {
  SUBMITTED: "grey2",
  IN_REVIEW: "grey1",
  PRESENTED_TO_CLIENT: "default",
  INTERVIEW: "info",
  ACCEPTED: "success",
  REJECTED: "error",
  WITHDRAWN: "grey4",
  DRAFT: "grey3",
  DELETED: "error",
  EXPIRED: "grey4",
};

export const JobApplicationStatus: FunctionComponent<IJobApplicationStatusProps> = memo(({ status, size = "xxs" }) => {
  const tCodelist = useCodelistTranslation();

  return (
    <Flex direction="row">
      <Header
        size={size}
        color={statusBadgeColorMap[status]}
        text={tCodelist("job-request-application-statuses", status)}
        weight="bold"
      />
    </Flex>
  );
});
